import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Text,
  VStack,
} from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

export const InterviewTypeDescriptions = () => {
  const { t } = useTranslation(['interview']);
  const interviewTypeDescriptionsData = [
    {
      id: 0,
      title: t('interview:interviewTypeDescriptions.languageTest.title'),
      description: t(
        'interview:interviewTypeDescriptions.languageTest.description'
      ),
    },
    {
      id: 1,
      title: t('interview:interviewTypeDescriptions.jobEntryInterview.title'),
      description: t(
        'interview:interviewTypeDescriptions.jobEntryInterview.description'
      ),
    },
    {
      id: 2,
      title: t('interview:interviewTypeDescriptions.exitInterview.title'),
      description: t(
        'interview:interviewTypeDescriptions.exitInterview.description'
      ),
    },
    {
      id: 3,
      title: t('interview:interviewTypeDescriptions.technicalInterview.title'),
      description: t(
        'interview:interviewTypeDescriptions.technicalInterview.description'
      ),
    },
    {
      id: 4,
      title: t('interview:interviewTypeDescriptions.roleBasedInterview.title'),
      description: t(
        'interview:interviewTypeDescriptions.roleBasedInterview.description'
      ),
    },
  ];

  return (
    <VStack spacing={4} align="stretch" borderRadius="xl" bg="white" p={4}>
      <Accordion allowMultiple borderWidth={0}>
        <AccordionItem borderWidth={0} sx={{ borderBottom: 'none' }}>
          <h2>
            <AccordionButton _hover={{ bg: 'none' }} borderRadius="md">
              <Box
                as="span"
                flex="1"
                textAlign="left"
                fontSize="18px"
                borderRadius="md"
                fontWeight={500}
              >
                {t('interview:interviewTypeDescriptionsTitle')}
              </Box>
              <AccordionIcon />
            </AccordionButton>
          </h2>
          <AccordionPanel pb={4} px={3} borderWidth={0}>
            <VStack align="stretch" spacing={3}>
              {interviewTypeDescriptionsData.map((item) => (
                <Box
                  key={item.id}
                  bg="white"
                  p={4}
                  py={3}
                  borderRadius="xl"
                  border="1px"
                  borderColor="gray.50"
                >
                  <Text color="black">{item.title}</Text>
                  <Text mt={1} color="gray.500">
                    {item.description}
                  </Text>
                </Box>
              ))}
            </VStack>
          </AccordionPanel>
        </AccordionItem>
      </Accordion>
    </VStack>
  );
};
